'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentVenmoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.1044 22C17.6016 22.821 17.8258 23.6667 17.8258 24.7349C17.8258 28.142 14.9167 32.5682 12.5556 35.6761H7.16282L5 22.746L9.72199 22.2978L10.8655 31.4984C11.934 29.758 13.2525 27.0231 13.2525 25.1585C13.2525 24.1379 13.0776 23.4427 12.8043 22.8703L17.1044 22Z",
          fill: "#008CFF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M23.2245 27.6945C24.0934 27.6945 26.281 27.297 26.281 26.0539C26.281 25.457 25.8589 25.1593 25.3614 25.1593C24.4911 25.1593 23.3489 26.2028 23.2245 27.6945ZM23.1249 30.1564C23.1249 31.6743 23.9691 32.2698 25.0882 32.2698C26.3069 32.2698 27.4738 31.972 28.9904 31.2014L28.4192 35.0797C27.3506 35.6017 25.6852 35.95 24.0688 35.95C19.9684 35.95 18.5009 33.4638 18.5009 30.3557C18.5009 26.3274 20.888 22.0499 25.8094 22.0499C28.519 22.0499 30.0341 23.5677 30.0341 25.681C30.0344 29.088 25.6607 30.1318 23.1249 30.1564Z",
          fill: "#008CFF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M43.6614 24.9848C43.6614 25.482 43.5861 26.2033 43.5109 26.6746L42.0941 35.6266H37.4961L38.7886 27.4204C38.8131 27.1979 38.8885 26.7498 38.8885 26.5012C38.8885 25.9042 38.5155 25.7553 38.067 25.7553C37.4714 25.7553 36.8743 26.0285 36.4767 26.228L35.0107 35.6267H30.3869L32.4993 22.224H36.5012L36.5519 23.2938C37.496 22.6722 38.7392 22 40.5031 22C42.8401 21.9997 43.6614 23.1937 43.6614 24.9848Z",
          fill: "#008CFF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M57.3117 23.5171C58.6287 22.5732 59.8721 22.0499 61.5864 22.0499C63.9473 22.0499 64.7685 23.2439 64.7685 25.035C64.7685 25.5322 64.6933 26.2535 64.6184 26.7248L63.203 35.6768H58.6038L59.9211 27.2972C59.9453 27.0732 59.9964 26.7999 59.9964 26.6266C59.9964 25.9545 59.6232 25.8055 59.1748 25.8055C58.6038 25.8055 58.0328 26.0541 57.6089 26.2782L56.1432 35.6769H51.5453L52.8623 27.2973C52.8865 27.0733 52.9362 26.8001 52.9362 26.6268C52.9362 25.9547 52.5626 25.8056 52.1159 25.8056C51.5191 25.8056 50.9233 26.0788 50.5256 26.2783L49.0584 35.6771H44.4361L46.5484 22.2743H50.5014L50.6257 23.3932C51.5453 22.7226 52.7874 22.0504 54.4527 22.0504C55.8946 22.0499 56.8384 22.6716 57.3117 23.5171Z",
          fill: "#008CFF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M73.918 27.421C73.918 26.3269 73.6442 25.5809 72.8247 25.5809C71.0103 25.5809 70.6375 28.7883 70.6375 30.4291C70.6375 31.6738 70.9858 32.4442 71.8053 32.4442C73.5203 32.4442 73.918 29.0617 73.918 27.421ZM65.9647 30.231C65.9647 26.0044 68.2013 22.0495 73.347 22.0495C77.2244 22.0495 78.6418 24.3377 78.6418 27.4961C78.6418 31.6737 76.4294 36 71.1594 36C67.2572 36 65.9647 33.4385 65.9647 30.231Z",
          fill: "#008CFF"
        }
      )
    ]
  }
);
const VpPaymentVenmoAsset = forwardRef(PaymentVenmoAsset);

export { VpPaymentVenmoAsset as default };
